<div class="">
  <div class="d-flex">
    <span class="ms-2 taskStage" *ngFor="let data of taskStageList; let idx = index"
      [style.grid-template-columns]="getColumnSizes(taskStageList)">
      <div class="stage_text" (mouseenter)="getToolTip(data)" [matTooltip]="tooltipText">
        {{ data.stageName }}
      </div>
      <div class="d-flex align-items-center my-tooltip" [matTooltip]="tooltipText"
        style="white-space: pre; padding: 3px !important;">
        <div class="">
          <img *ngIf="data.stage == 'Passed'" src="../../../assets/img/cr_module/green_tick.svg" width="16" height="16"
            alt="passed" />
        </div>

        <div class="">
          <svg *ngIf="data.stage == 'Current'" xmlns="http://www.w3.org/2000/svg" width="16" height="17"
            viewBox="0 0 16 17" fill="none">
            <path id="Vector"
              d="M8 0.747009C6.41775 0.747009 4.87103 1.2162 3.55544 2.09525C2.23985 2.9743 1.21447 4.22373 0.608967 5.68554C0.00346628 7.14735 -0.15496 8.75588 0.153721 10.3077C0.462403 11.8596 1.22433 13.285 2.34315 14.4039C3.46197 15.5227 4.88743 16.2846 6.43928 16.5933C7.99113 16.902 9.59966 16.7435 11.0615 16.138C12.5233 15.5325 13.7727 14.5072 14.6518 13.1916C15.5308 11.876 16 10.3293 16 8.74701C15.9978 6.62596 15.1542 4.59243 13.6544 3.09263C12.1546 1.59282 10.121 0.749249 8 0.747009ZM11.5123 7.33624L7.20462 11.6439C7.14746 11.7011 7.07959 11.7465 7.00489 11.7775C6.93018 11.8085 6.8501 11.8244 6.76923 11.8244C6.68836 11.8244 6.60828 11.8085 6.53358 11.7775C6.45887 11.7465 6.391 11.7011 6.33385 11.6439L4.48769 9.79778C4.37222 9.68231 4.30735 9.52569 4.30735 9.36239C4.30735 9.19909 4.37222 9.04248 4.48769 8.92701C4.60317 8.81154 4.75978 8.74667 4.92308 8.74667C5.08638 8.74667 5.24299 8.81154 5.35846 8.92701L6.76923 10.3385L10.6415 6.46547C10.6987 6.40829 10.7666 6.36294 10.8413 6.332C10.916 6.30105 10.9961 6.28513 11.0769 6.28513C11.1578 6.28513 11.2378 6.30105 11.3126 6.332C11.3873 6.36294 11.4551 6.40829 11.5123 6.46547C11.5695 6.52264 11.6148 6.59052 11.6458 6.66523C11.6767 6.73993 11.6927 6.82 11.6927 6.90085C11.6927 6.98171 11.6767 7.06178 11.6458 7.13648C11.6148 7.21119 11.5695 7.27906 11.5123 7.33624Z"
              fill="#FFA500" />
          </svg>
        </div>

        <div class="">
          <img *ngIf="data.stage == 'Pending'" src="../../../assets/img/cr_module/blue_tick.svg" width="16" height="16"
            alt="pending" />
        </div>

        <svg *ngIf="idx < taskStageList.length-1" class="ms-2 mt-1" xmlns="http://www.w3.org/2000/svg" width="60"
          height="2" viewBox="0 0 60 2" fill="none">
          <rect width="60" height="2" rx="1"
            [ngStyle]="{fill: data.stage == 'Passed' ? '#2F6926' : data.stage == 'Current' ? '#AB0808' : data.stage == 'Pending' ? '#126DA0' : ''}"
            fill-opacity="0.5" />
        </svg>
      </div>
    </span>
  </div>
</div>